export default __webpack_public_path__ + "static/media/search-icon-asset.b72decef.svg";